import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Row, Col, Button } from 'reactstrap';
import { logout } from '../actions/index';
import { bindActionCreators } from 'redux';

const mapStateToProps = state => {
    return { agente: state.agente };
};

const mapDispatchToProps = dispatch => {
    return {
        ...bindActionCreators({ logout }, dispatch)
    };
};

class HomeDirectivo extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
        this.cerrarSesion = this.cerrarSesion.bind(this);
    }

    async cerrarSesion() {
        this.props.logout();
    }

    render() {
        if (this.props.agente.nombreAgente === undefined || this.props.agente === undefined || this.props.agente === {}) {
            return <Redirect to={{ pathname: '/Cliente' }} />
        }
        return (
            <div>
                <Row>
                    <Col xs="3">Bienvenido amigo Directivo!</Col>
                    <Col xs="6"><center>{this.props.agente.nombreAgente + " " + this.props.agente.apellidoAgente}</center></Col>
                    <Col xs="3"><Button color="danger" onClick={this.cerrarSesion}>Logout</Button>{' '}</Col>
                </Row>
                <br />
            </div>
        );
    }


}

export default connect(mapStateToProps, mapDispatchToProps)(HomeDirectivo);
